import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { CollectionsTable } from "./components/CollectionsTable";
import ProfileLayout from "../global/ProfileLayout";
import { TokensTable } from "../global/TokensTable";
import { fetchTestnetHoldings, fetchUserHoldings } from "../../utils/holdings";
import { useWeb3React } from "@web3-react/core";

const RowWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: "15px",
  width: "98%",
  minHeight: "180px",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  margin: "0px auto",
  marginBottom: "30px",
  paddingBottom: "30px",
  // margin: "20px",
}));

const HeaderRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "98%",
});

const Overview = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <ProfileLayout collectionCount={false} nftCount={false}>
      <Stack direction="column" width="100%" marginTop="30px">
        {/* <RowWrapper>
          <HeaderRow>
            <Typography
              variant="subtitle2"
              fontWeight="500"
              color={colors.black[900]}
            >
              Collectibles
            </Typography>
          </HeaderRow>

          <CollectionsTable />
        </RowWrapper> */}

        <RowWrapper>
          <HeaderRow>
            <Typography
              variant="subtitle2"
              fontWeight="500"
              color={colors.black[900]}
            >
              Tokens
            </Typography>
          </HeaderRow>
          <TokensTable />
        </RowWrapper>
      </Stack>
    </ProfileLayout>
  );
};

export default Overview;
